"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sandwichIds = void 0;
exports.sandwichIds = {
    inboundSwitchTracker: {
        started: 'transfers-inbound-switch-tracker-started',
        omrDue: 'transfers-inbound-switch-tracker-started-omr-due',
        onSupply: 'transfers-inbound-switch-tracker-started-on-supply ',
    },
};
